import commonMessages from '../messages/common.json';

const OPEN_PREFIX = 'store.openMessage.' as const;

type OpenMessageKey = keyof typeof commonMessages.store.openMessage;

export type CommonStoreMessageKey = `${typeof OPEN_PREFIX}${OpenMessageKey}`;

export const isCommonStoreMessageKey = (value: string): value is CommonStoreMessageKey => {
  if (!value.startsWith(OPEN_PREFIX)) {
    return false;
  }

  const key = value.slice(OPEN_PREFIX.length);
  return key in commonMessages.store.openMessage;
};
